import { render } from "./StoryCard.vue?vue&type=template&id=25d69d12&scoped=true"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=25d69d12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25d69d12"

export default script